





















































































import Vue from 'vue'

import SectionTitle from '@/product/components/SectionTitle.vue'
import BuyingOptions from '@/product/components/BuyingOptions.vue'
import StockLibrary from '@/product/components/printingOptions/StockLibrary.vue'
import SelectColorPattern  from '@/product/components/printingOptions/SelectColorPattern.vue'
import SelectEditPattern  from '@/product/components/printingOptions/SelectEditPattern.vue'
import SelectColorPatternMobile  from '@/product/components/printingOptions/SelectColorPatternMobile.vue'
import SelectEditPatternMobile  from '@/product/components/printingOptions/SelectEditPatternMobile.vue'

import {
  ProductSku,
  ProductState,
  BuyingOption,
  ProductColorPattern,
  ProductEditPattern,
  PRODUCT_SELECTION_ERROR_TYPES
} from '@/product/types'
import { COLOR_PATTERN_TYPES } from '@/common/constants'
import { scrollToElement } from '@/helper'

export default Vue.extend({
  components: {
    SectionTitle,
    BuyingOptions,
    StockLibrary,
    SelectColorPattern,
    SelectEditPattern,
    SelectColorPatternMobile,
    SelectEditPatternMobile
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    disablePlainGood: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    isPrinting: boolean
    previousSelectedColorPattern?: ProductColorPattern
    previousSelectedEditPattern?: ProductEditPattern
  } {
    return {
      isPrinting: true,
      previousSelectedColorPattern: undefined,
      previousSelectedEditPattern: undefined
    }
  },
  computed: {
    notSupportPrintingMsg(): string {
      return `印刷ができない商品です。${
        this.isMobile
          ? ''
          : '商品への印刷をご希望の場合は、他の商品をお選びください。'
      }`
    },
    buyingPrintingOptions(): BuyingOption[] {
      return [
        {
          displayName: this.isMobile ? '印刷する' : '印刷・刺繍をする',
          isDisabled: false,
          isBuying: true
        },
        {
          displayName: this.isMobile ? '印刷しない' : '印刷・刺繍をしない',
          isDisabled: this.disablePlainGood,
          isBuying: false
        }
      ]
    },
    storeState(): ProductState {
      return this.$store.state
    },
    productSku(): ProductSku {
      return this.storeState.productDetail.sku
    },
    colorPatterns(): ProductColorPattern[] {
      return (
        this.disablePlainGood
          ? this.productSku.skuColorPatterns.filter(
              item => item.id !== this.colorPatternPlainId
            )
          : this.productSku.skuColorPatterns
      ) as ProductColorPattern[]
    },
    filteredColorPatterns(): ProductColorPattern[] {
      return this.colorPatterns.filter(
        item => item.colorPattern.type !== COLOR_PATTERN_TYPES.PLAIN
      )
    },
    editPatterns(): ProductEditPattern[] {
      return this.productSku.allSkuEditPatterns as ProductEditPattern[]
    },
    filteredEditPatterns(): ProductEditPattern[] {
      return this.productSku.skuEditPatterns as ProductEditPattern[]
    },
    selectedColorPatternOption(): ProductColorPattern | undefined {
      return this.$store.getters.selectedColorPatternOption
    },
    selectedEditPatternOption(): ProductEditPattern | undefined {
      return this.$store.getters.selectedEditPattern
    },
    colorPatternPlainId(): string {
      return this.productSku.skuColorPatterns.find(
        pattern => pattern.colorPattern.type === COLOR_PATTERN_TYPES.PLAIN
      )!.id
    },
    highlightPrintingOptionsSelection(): boolean {
      return this.storeState.selectionErrors[
        PRODUCT_SELECTION_ERROR_TYPES.PRINTING_OPTION
      ].highlightInvalidElement
    },
    isNotSupportPrinting(): boolean {
      return this.colorPatterns.length <= 1
        && this.colorPatterns[0].colorPattern.type === COLOR_PATTERN_TYPES.PLAIN
    },
    isWithLibraryDesign(): boolean {
      return !!this.storeState.stockLibraryDesign.uuid
    },
    colorPatternErrorMessage(): string {
      return this.storeState.selectionErrors[
        PRODUCT_SELECTION_ERROR_TYPES.PRINTING_OPTION
      ].errorMessage || ''
    },
    isSelectingColorPatternPlain(): boolean {
      return this.selectedColorPatternOption?.id === this.colorPatternPlainId
    },
    showRequiredColorPatternMessage(): boolean {
      return (
        this.isPrinting &&
        this.selectedColorPatternOption?.id === this.colorPatternPlainId
      )
    },
    isInvalidColorPattern(): boolean {
      return (
        this.isPrinting &&
        this.selectedColorPatternOption?.id === this.colorPatternPlainId
      )
    },
    enableAllEditPatterns(): boolean {
      return this.isPrinting && this.isSelectingColorPatternPlain
    }
  },
  watch: {
    isInvalidColorPattern(newVal: boolean) {
      if (this.highlightPrintingOptionsSelection && !newVal) {
        this.$store.commit(
          'solveSelectErrorItem',
          PRODUCT_SELECTION_ERROR_TYPES.PRINTING_OPTION
        )
      }
    }
  },
  created() {
    this.isPrinting =
      (!this.$route.query.psi ||
        this.disablePlainGood ||
        !this.isSelectingColorPatternPlain) &&
      !this.isNotSupportPrinting

    this.updateStateIsPrintingSelected(this.isPrinting)
  },
  methods: {
    refreshProductInfo() {
      this.$emit('onChangeProductPsi', { _disabledLoading: true })
    },
    onUpdateColorPattern(id: string) {
      if (this.selectedColorPatternOption?.id !== id) {
        this.$store.commit('updateSelectedColorPattern', id)
        this.refreshProductInfo()
      }
    },
    onUpdateEditPattern(id: string) {
      if (this.$store.getters.invalidPrintingSelection) {
        this.$store.dispatch('showColorPatternSelectionWarning')
        this.$nextTick(() => scrollToElement('[class*="pr-InvalidOrderProcess"]'))
        return
      }

      if (id !== this.selectedEditPatternOption?.id) {
        this.$store.commit('setSelectedId', {
          fieldName: 'selectedEditPattern', id
        })
        this.refreshProductInfo()
      }
    },
    updateColorAndEditPattern(colorPatternId: string, editPatternId: string) {
      if (this.selectedColorPatternOption?.id !== colorPatternId) {
        this.$store.commit('updateSelectedColorPattern', colorPatternId)
      }
      if (this.selectedEditPatternOption?.id !== editPatternId) {
        this.$store.commit('setSelectedId', {
          fieldName: 'selectedEditPattern', id: editPatternId
        })
      }
      this.refreshProductInfo()
    },
    updateStateIsPrintingSelected(value: boolean) {
      this.$store.commit('setIsPrintingSelected', value)
    },
    setIsPrinting(isPrinting: boolean) {
      if (this.isPrinting === isPrinting) return
      this.isPrinting = isPrinting
      this.updateStateIsPrintingSelected(isPrinting)
      // switching from printing to not printing
      if (!isPrinting) {
        this.previousSelectedColorPattern = this.selectedColorPatternOption
        this.previousSelectedEditPattern = this.selectedEditPatternOption
        this.onUpdateColorPattern(this.colorPatternPlainId)
        this.$store.commit(
          'solveSelectErrorItem',
          PRODUCT_SELECTION_ERROR_TYPES.PRINTING_OPTION
        )
      }
      // switching from not printing to printing
      if (isPrinting) {
        if (this.previousSelectedColorPattern && this.previousSelectedEditPattern) {
          this.updateColorAndEditPattern(
            this.previousSelectedColorPattern.id,
            this.previousSelectedEditPattern.id
          )
        } else if (this.$store.getters.isFastShippingSelected) {
          this.onUpdateColorPattern(
            this.filteredColorPatterns[0]?.id
          )
        }
        this.previousSelectedColorPattern = undefined
        this.previousSelectedEditPattern = undefined
      }
    }
  }
})
